import React, { useState } from 'react'
import "./Addrest.css"
import { useNavigate } from 'react-router-dom';



function Addrest() {

    const[restname,setRestname]=useState("");
    const[foodname,setFoodname]=useState("");
    const[description,setdescname]=useState("");
    const[available,setAvailablename]=useState("");
    const[img,setImgname]=useState("");
    const[price,setPrice]=useState(0);
    const user={restname,foodname,description,available,img,price}
    const navigate=useNavigate();

    const handleChange=(e)=>{
        e.preventDefault();
        console.log(user);
  
        fetch("https://food-delivery-sid-api.herokuapp.com/api/add",{
          method:"POST",
          body:JSON.stringify(user),
          mode:'cors',
          headers:{
            'Content-type':'application/json'
          }
        })
        .then((data)=>{
          console.log(data)
          navigate('/foods')
         
          
        })
        .catch((err)=>{
          console.log(err)
        })
        
      }
  


  return (
    <div  className='addrest-ele'>
        <div className='addrest-img'><h1></h1></div>

        <form className='addrest-form'>

      <label className='rest-l'>Rastaurent name</label>
      <input className='rest-input' type="text"  required="required"  onChange={(e)=>{
        setRestname(e.target.value);
      }}/>

      <label className='rest-l'>Food name</label>
      <input className='rest-input' type="text"  required="required"  onChange={(e)=>{
        setFoodname(e.target.value);
      }}/>

      <label className='rest-l'>description</label>
      <input className='rest-input' type="text"  required="required"  onChange={(e)=>{
        setdescname(e.target.value);
      }}></input>

      <label className='rest-l'>available</label>
      <input className='rest-input' type="text"  onChange={(e)=>{
        setAvailablename(e.target.value);
      }}></input>

      <label className='rest-l'>Img</label>
      <input className='rest-input' type="text"  required="required"  onChange={(e)=>{
        setImgname(e.target.value);
      }}></input>
     

      <button onClick={handleChange} className='rest-button'>submit</button>
      </form>
    </div>
  )
}

export default Addrest
